import { apiClient } from './client';
import type { WazuhAgent, WazuhDashboardSummary, DevicesSummary } from '../types';

export const wazuhApi = {
  async getSummary(): Promise<WazuhDashboardSummary> {
    const { data } = await apiClient.get<WazuhDashboardSummary>('/wazuh/summary');
    return data;
  },
  async getAgents(params: { status?: string; limit?: number }): Promise<WazuhAgent[]> {
    const { data } = await apiClient.get<{ agents: WazuhAgent[] }>('/wazuh/agents', { params });
    return data.agents;
  },
  async getDevices(limit?: number): Promise<DevicesSummary> {
    const { data } = await apiClient.get<DevicesSummary>('/wazuh/devices', { params: { limit } });
    return data;
  },
};
